import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_92_8",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "20",
      height: "20"
    }, [
      _createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_92_8)" }, [
      _createElementVNode("path", {
        d: "M1.66663 17.5V15.8333H9.16663V6.52079C8.80551 6.39579 8.49301 6.20135 8.22913 5.93746C7.96524 5.67357 7.77079 5.36107 7.64579 4.99996H4.99996L7.49996 10.8333C7.49996 11.5277 7.21524 12.118 6.64579 12.6041C6.07635 13.0902 5.38885 13.3333 4.58329 13.3333C3.77774 13.3333 3.09024 13.0902 2.52079 12.6041C1.95135 12.118 1.66663 11.5277 1.66663 10.8333L4.16663 4.99996H2.49996V3.33329H7.64579C7.81246 2.84718 8.11107 2.44788 8.54163 2.13538C8.97218 1.82288 9.45829 1.66663 9.99996 1.66663C10.5416 1.66663 11.0277 1.82288 11.4583 2.13538C11.8888 2.44788 12.1875 2.84718 12.3541 3.33329H17.5V4.99996H15.8333L18.3333 10.8333C18.3333 11.5277 18.0486 12.118 17.4791 12.6041C16.9097 13.0902 16.2222 13.3333 15.4166 13.3333C14.6111 13.3333 13.9236 13.0902 13.3541 12.6041C12.7847 12.118 12.5 11.5277 12.5 10.8333L15 4.99996H12.3541C12.2291 5.36107 12.0347 5.67357 11.7708 5.93746C11.5069 6.20135 11.1944 6.39579 10.8333 6.52079V15.8333H18.3333V17.5H1.66663ZM13.8541 10.8333H16.9791L15.4166 7.20829L13.8541 10.8333ZM3.02079 10.8333H6.14579L4.58329 7.20829L3.02079 10.8333ZM9.99996 4.99996C10.2361 4.99996 10.434 4.9201 10.5937 4.76038C10.7534 4.60065 10.8333 4.40274 10.8333 4.16663C10.8333 3.93051 10.7534 3.7326 10.5937 3.57288C10.434 3.41315 10.2361 3.33329 9.99996 3.33329C9.76385 3.33329 9.56593 3.41315 9.40621 3.57288C9.24649 3.7326 9.16663 3.93051 9.16663 4.16663C9.16663 4.40274 9.24649 4.60065 9.40621 4.76038C9.56593 4.9201 9.76385 4.99996 9.99996 4.99996Z",
        fill: "#1C1B1F"
      })
    ], -1)
  ]))]))
}
export default { render: render }